import React from 'react'
import { Container } from 'reactstrap'
import "./layout.css"



const Footer=()=>{
    return (
        // <Container  fluid tag="footer" style={{color:"#e7213e",zIndex:"-1"}} className="text-center fixed-bottom p-3 footer" >

           
        //     <div>
        //        <span  style={{color:"#e7213e"}}> Copyright ©2021 ProjectBook . All rights reserved.</span> Akshad & Vaibhav
                
        //     </div>
        // </Container>
        <footer class="footer">
  {/* <div class="container">
    <p class="text-muted foot" style={{color:"black"}}>Copyright ©2021 ProjectBook . All rights reserved.</p>
  </div> */}
</footer>
    )
}
export default Footer